import React from 'react';
import { RadioGroup, Radio } from 'react-radio-group';

export default class ResidenceStatus extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isResident: true
        };
    }

    handleChange = (value) => {
        if (this.props.handleChange) {
            this.props.handleChange(value);
        }

        this.setState(Object.assign({},
            this.state,
            {
                isResident: value
            }
        ));
    }

    render() {
        const { isResident } = this.state;

        return (
            <div className='pcb-radio' style={{"padding-top": "15px"}}>
                <label>
                    Residence Status <i
                        className="fa fa-question-circle"
                        data-tip="See help article for more info:
                            <a href='http://help.payrollpanda.my/12465-malaysia-payroll-faq/how-to-determine-residence-status' target='_blank'>
                                How to determine residence status?
                            </a>"
                    >
                    </i>
                </label>

                <RadioGroup className='row'
                    name='residenceStatus'
                    selectedValue={isResident}
                    onChange={this.handleChange}>

                    <div className='col-sm-6'>
                        <label className='option'>
                            Resident
                            <Radio value={true} />
                            <span className='check'></span>
                        </label>
                    </div>

                    <div className='col-sm-6'>
                        <label className='option'>
                            Non-resident
                            <Radio value={false} />
                            <span className='check'></span>
                        </label>
                    </div>
                </RadioGroup>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/ResidenceStatus.js